export default __webpack_public_path__ + "static/media/breaker2.2f207e8a.png";